// extracted by mini-css-extract-plugin
module.exports = {"budget":"BudgetDescription_budget__2sPVN","fadeIn":"BudgetDescription_fadeIn__3IadR","fadeOut":"BudgetDescription_fadeOut__3MYwj"};